import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const DocumentService = {
  manuallyGenerateDoc: async (user, processId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/data-entry/process-data/generate-template-doc/${processId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  getManuallyGenerateDoc: async (user, processId, activityTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/data-entry/process-data/get-generated-template-doc/${processId}/${activityTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  checkForTemplateDoc: async (user, activityTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/data-entry/process-data/check-for-template-doc/${activityTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
}
